import template from './calendarComponent.html';
import controller from './calendarComponent.controller';
import './calendarComponent.scss';

let calendarComponentComponent = {
  restrict: 'E',
  bindings: {
    options: '<',
    onClick: '&',
    onHoverIn: '&',
    onHoverOut: '&',
    beforeShowDay: '&',
    isMobileApp: '<',
    dateToday: '<',
    onClickPrevious: '&',
    onClickNext: '&'
  },
  template,
  controller
};

export default calendarComponentComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarComponent/calendarComponent.component.js